module.exports = __webpack_public_path__ + "static/img/mb-13.8a22b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/mb-13.jpg
// module id = L9ck
// module chunks = 1